<template>
    <div class="components-container">
        <el-row>
            <div class="titles"><span class="fonts">备注</span></div>
        </el-row>
        <el-row>
            <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 5 }" v-model="coms" :disabled="editDisableState" maxlength="500"
                show-word-limit></el-input>
        </el-row>
        <el-row>
            <div class="titles">
                <span class="fonts">人才培养方案原件</span>
            </div>
            <div class="uploadTips">第一次保存之后才可上传人才培养方案原件</div>
            <el-col :span="12">
                <el-upload class="upload-demo" :action="url" :file-list="fileList" style="margin-top: 10px" :data="param"
                    :on-error="onError" :on-success="onSuccess" :before-remove="beforeRemove" :on-remove="onRemove"
                    :limit="1" :on-exceed="onExceed" :disabled="nshow">
                    <el-button size="small" type="success" :disabled="nshow">上传</el-button>
                    <el-button size="small" type="primary" @click.stop="downloadScheme">下载</el-button>
                    <el-button size="small" type="danger" :disabled="nshow" @click.stop="onRemove">删除</el-button>
                </el-upload>
            </el-col>
        </el-row>
    </div>
</template>


<script>
    export default {
        props: ["editDisableState", "etype"],
        computed: {
            url() {
                return (
                    Vue.prototype.HOST_PROXY_ADMIN +
                    "/teachingManage/teachingScheme/upload"
                );
            },
            nshow() {
                return this.etype != "0";
            },
        },

        data() {
            return {
                fileList: [],
                param: {
                    schemeId: null,
                },
                coms: "",
            };
        },
        mounted() {},
        methods: {
            onError(err, file, fileList) {
                this.$notify({
                    title: "错误",
                    message: err,
                    type: "error",
                    duration: 3000,
                });
            },
            beforeRemove(file, fileList) {},
            onRemove(file, fileList) {
                this.$api.teachingManage.teachingScheme.deleteFile({
                    data: {
                        newFileName: this.fileList[0].originPath,
                        schemeId: this.param.schemeId,
                    },
                }).then((res) => {
                    this.fileList = [];
                }).catch((err) => {
                    console.log(err);
                });
            },
            onSuccess(res, file, fileList) {
                let ele = {
                    name: res.name,
                    url: Vue.prototype.HOST_PROXY_ADMIN + res.url,
                    originPath: res.originPath,
                };
                this.$nextTick(() => {
                    this.fileList.pop();
                    this.fileList.push(ele);
                });
            },
            onExceed(files, fileList) {
                //overwrite
                this.$api.teachingManage.teachingScheme .uploadScheme({
                    headers: {
                        "Content-Type": "multipart/form-data;charset=UTF-8",
                    },
                    data: {
                        file: files[0],
                        schemeId: this.param.schemeId,
                    },
                }).then((res) => {
                    let ele = {
                        name: res.data.name,
                        url: Vue.prototype.HOST_PROXY_ADMIN + res.data.url,
                        originPath: res.data.originPath,
                    };
                    this.$nextTick(() => {
                        this.fileList.pop();
                        this.fileList.push(ele);
                    });
                }).catch((err) => {
                    this.onError(err);
                });
            },
            downloadScheme() {
                if (this.fileList.length == 0) {
                    this.$alert("尚未上传人才培养方案原件", "提示", {
                        confirmButtonText: "确定",
                    });
                    return;
                }

                let exist = this.isExistFile(this.fileList[0].url);
                if (exist) {
                    this.downloadFile(this.fileList[0].url, this.fileList[0].name);
                } else {
                    this.$notify({
                        title: "错误",
                        message: "文件不存在，如有疑问请联系管理员！",
                        type: "error",
                        duration: 3000,
                    });
                }

                // let link = document.createElement("a");
                // link.style.display = "none";
                // link.href = this.fileList[0].url;
                // let exist = this.isExistFile(link.href);
                // if (exist) {
                //     link.setAttribute("download", this.fileList[0].name);
                //     link.onclick = function (){
                //         alert(this.fileList[0].url);
                //     };
                //     document.body.appendChild(link);
                //     link.click();
                //     document.body.removeChild(link);
                // } else {
                //     this.$notify({
                //         title: "错误",
                //         message: "文件不存在，如有疑问请联系管理员！",
                //         type: "error",
                //         duration: 3000,
                //     });
                //     //this.onRemove();
                // }
            },
            downloadFile(url, fileName) {
                let x = new XMLHttpRequest();
                x.open("GET", url, true);
                x.responseType = 'blob';
                x.onload = function(e) {
                    var url = window.URL.createObjectURL(x.response)
                    var a = document.createElement('a');
                    a.href = url
                    a.download = fileName;
                    a.click()
                }
                x.send();
            },
            isExistFile(url) {
                if (url == null || url == undefined || url == "") {
                    return false;
                }
                let xmlhttp;
                if (window.XMLHttpRequest) {
                    xmlhttp = new XMLHttpRequest();
                } else {
                    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                }
                xmlhttp.open("GET", url, false);
                xmlhttp.send();
                if (xmlhttp.readyState == 4) {
                    if (xmlhttp.status == 200) return true;
                    //url存在
                    else if (xmlhttp.status == 404) return false;
                    //url不存在
                    else return false; //其他状态
                }
            },
        },
    };
</script>

<style scoped>
    .uploadTips {
        width: 100%;
        height: 50px;
        line-height: 50px;
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// comment.vue?710b2aa4